module.exports = __webpack_public_path__ + "img/pr-7.e8f8acf4.png";